import { Component, OnInit } from '@angular/core';
import { GuideService } from '../../services/guide.service';

@Component({
  selector: 'app-guide-list',
  templateUrl: './guide-list.component.html',
  styleUrls: ['./guide-list.component.less'],
})
export class GuideListComponent implements OnInit {
  guides: any[] = [];
  selectedGuide: any = null;
  showModal: boolean = false;

  constructor(private guideService: GuideService) {}

  ngOnInit(): void {
    this.getGuides();
  }

  getGuides() {
    this.guideService.getGuides().subscribe((data: any) => {
      this.guides = data;
    });
  }

  openGuide(guide: any) {
    this.selectedGuide = guide;
    this.showModal = true;
    console.log("guide-list.component.ts [8c914c] openGuide: ", this.selectedGuide, this.showModal);
  }

  closeModal() {
    this.selectedGuide = null;
    this.showModal = false;
  }
}
